/* global screenfull */
import cx                     from 'classnames';
import React, { PropTypes }   from 'react';
import VideoActions           from 'actions/video_actions';
import screenfull             from 'screenfull';

export default React.createClass({
  displayName: 'Player.FullscreenButton',
  propTypes: {
      isFullScreen: PropTypes.bool,
          screenId: PropTypes.string,
    hasMobileStyle: PropTypes.bool,
           isVideo: PropTypes.bool
  },
  mixins: [ React.PureRenderMixin ],
  fullscreen(e) {
    e.preventDefault();
    if(this.props.isFullScreen) {
      VideoActions.exitFullScreen();
      document.getElementById('ads-pos-122-container').style.zIndex = 2;
      if(screenfull) {
        screenfull.exit();
      }
    } else {
      VideoActions.fullScreen();
      document.getElementById('ads-pos-122-container').style.zIndex = 0;
      if(screenfull) {
        document.getElementById('tvPlayer').classList.remove('fade-in');
        screenfull.request(document.getElementById(this.props.screenId));
      }
    }
  },
  render() {
    const classNames = cx({
      'video-player-fullscreen-button': true,
                       'is-fullscreen': this.props.isFullScreen
    });
    return (
        <button className={classNames} onClick={this.fullscreen}>FS</button>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/player/fullscreen_button.jsx
 **/